<template>
  <div class="bodycontent">
    <div class="page_title">
      <div class="title_text">
        短信设置
      </div>
      <div>
        <el-button size="medium" @click="showOrderList = true" type="primary"
          >充值记录</el-button
        >
        <!-- <el-button size="medium" @click="showSendList = true" type="primary"
          >发送记录</el-button
        > -->
      </div>
    </div>
    <div class="page_form">
      <!-- <el-form
        :model="detailData"
        size="small"
        label-width="120px"
        v-if="hasSet"
      >
        <el-form-item label="邮箱">{{ detailData.email }}</el-form-item>
        <el-form-item label="key">{{ detailData.app_key }}</el-form-item>
        <el-form-item label="密钥">{{ detailData.app_secret }}</el-form-item>
        <el-form-item label="签名">{{ detailData.app_name }}</el-form-item>
        <el-form-item label="验证码条数"
          >{{ detailData.code_num }}
          <span
            ><el-button type="text" @click="recharge(1)">充值</el-button></span
          >
        </el-form-item>
        <el-form-item label="营销短信条数" v-if="false"
          >{{ detailData.sem_num }}
          <span
            ><el-button type="text" @click="recharge(2)">充值</el-button></span
          >
        </el-form-item>
        <el-form-item label="状态">{{ detailData.show_status }}</el-form-item>
        <el-form-item label="申请时间">{{
          detailData.create_time
        }}</el-form-item>
      </el-form> -->
      <div class="part_title">短信余额</div>
      <div class="balance_box">
        <div class="balance_title">短信（条）</div>
        <div class="balance_num">
          <div class="num">{{ detailData.code_num }}</div>
          <span style="margin-top:-10px">
            <el-button type="primary" @click="recharge(1)">购买短信</el-button>
          </span>
        </div>
      </div>
      <div class="part_title">短信发送记录</div>
      <div style="margin: 0 10px">
        <send-list></send-list>
      </div>
    </div>
    <!-- <div class="page_bottom" v-if="showButton">
      <el-button type="primary" @click="showForm = true" size="small"
        >申请短信账号</el-button
      >
    </div> -->
    <el-dialog
      :visible.sync="showForm"
      width="500px"
      title="申请短信账号"
      @close="closeForm()"
    >
      <el-form
        :model="formData"
        size="small"
        label-width="100px"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="短信签名" prop="app_name">
          <el-input class="input_box" v-model="formData.app_name"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input class="input_box" v-model="formData.email"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit_button">
        <el-button size="small" type="primary" @click="submit()"
          >提交</el-button
        >
        <el-button size="small" @click="closeForm()">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showRecharge"
      width="700px"
      title="短信充值"
      @close="closeRecharge()"
    >
      <div class="recharge">
        <div class="recharge_left">
          <div
            class="recharge_item"
            v-for="(item, index) in rechargeItems"
            :key="index"
            @click="selectRechargeItem(index)"
            :class="{
              status_normal: !item.selected,
              status_selected: item.selected,
            }"
          >
            <div class="item_title">
              {{ item.name }}{{ rechargeForm.show_type }}
            </div>
            <div class="item_price" v-if="item.num == 2000">
              <!-- ￥<span>{{item.num * rechargeForm.price}}</span>元 -->
              低至 {{ rechargeForm.price }}元/条
            </div>
            <div class="item_price" v-if="item.num == 5000">
              低至{{ rechargeForm.price }}元/条
            </div>
            <div class="item_price" v-if="item.num == 10000">
              低至{{ rechargeForm.price }}元/条
            </div>
            <div class="item_price" v-if="item.num == 100000">
              低至{{ rechargeForm.price }}元/条
            </div>
            <div class="star_img" v-if="item.star">
              <img src="@/assets/images/star2.png" alt="" />
            </div>
          </div>
        </div>
        <div class="recharge_right">
          <div v-if="false">
            数量：<el-input-number
              v-model="rechargeForm.num"
              size="small"
              :min="0"
            ></el-input-number>
          </div>
          <div>共 {{ rechargeForm.selectNum * rechargeForm.num }} 条</div>
          <div class="show_price">
            价格：￥<span>{{
              rechargeForm.selectNum * rechargeForm.num * rechargeForm.price
            }}</span
            >元
          </div>
          <div>
            <el-button style="width: 100%" type="primary" @click="submitBuy()"
              >立即购买</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showQrcode"
      width="340px"
      title="扫码支付"
      @close="closeCode()"
    >
      <div class="qrcode_box" id="qrcode" ref="qrcode"></div>
    </el-dialog>
    <el-dialog :visible.sync="showOrderList" width="80%">
      <order-list></order-list>
    </el-dialog>
    <el-dialog :visible.sync="showSendList" width="80%">
      <send-list></send-list>
    </el-dialog>
  </div>
</template>
<script>
import {
  getSMSConfig,
  applySMS,
  SMSPrice,
  SMSQrcode,
  SMSSendLogs,
  SMSOrderLisg,
  SMSOrderDetail,
} from "@/api/set";
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
import OrderList from "./rechargeList";
import SendList from "./sendList";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "status"]),
  },
  components: {
    OrderList,
    SendList,
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      console.log(value);
      if (value == "") {
        callback(new Error("请输入邮箱"));
      } else {
        var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式!"));
        }
      }
    };
    return {
      detailData: {}, //设置信息
      hasSet: false, //是否已设置
      showButton: false, //是否显示申请按钮
      showForm: false, //申请表单弹窗
      formData: {
        //表单信息
        app_name: "",
        email: "",
      },
      price: {}, //短信价格
      ordersn: "", // 查询支付状态唯一字符串
      showRecharge: false, // 充值弹窗
      rechargeType: 1, // 充值类型：1.验证码 2.营销短信
      showQrcode: false, // 二维码弹窗
      qrcode: "", // 二维码内容
      showOrderList: false, // 充值记录列表弹窗
      showSendList: false, // 发送记录列表弹窗
      rechargeItems: [
        { name: "2000条", num: 2000, selected: false },
        { name: "5000条", num: 5000, selected: false, star: true },
        { name: "1万条", num: 10000, selected: false },
        { name: "10万条", num: 100000, selected: false },
      ],
      rechargeForm: {
        num: 1,
        type: 1,
        price: 0,
        selectNum: 0,
      },
      rules: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        app_name: [
          { required: true, message: "请输入短信签名", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      getSMSConfig(data).then((res) => {
        if (res.code == 200 && res.data) {
          this.detailData = res.data;
          this.hasSet = true;
          this.detailData.create_time = this.dateFormat(
            this.detailData.create_time
          );
          this.detailData.agree_time = this.dateFormat(
            this.detailData.agree_time
          );
          this.detailData.refuse_time = this.dateFormat(
            this.detailData.refuse_time
          );
          this.detailData.show_status =
            this.detailData.check_status == 0
              ? "待审核"
              : this.detailData.check_status == 1
              ? "审核通过"
              : "审核失败";
          this.showButton = this.detailData.check_status == 2 ? true : false;
        } else {
          this.showButton = true;
        }
      });
      SMSPrice(data).then((res) => {
        if (res.code == 200) {
          this.price = {
            code: Number(res.data.code_price),
            market: Number(res.data.market_price),
          };
        }
      });
    },
    // 表单提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log(1);
          var data = Object.assign({}, this.formData);
          data.token = this.token;
          data.app_id = this.app_id;
          applySMS(data).then((res) => {
            if (res.code == 200) {
              this.closeForm();
              this.init();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 关闭弹窗
    closeForm() {
      this.showForm = false;
      this.$refs["ruleForm"].resetFields();
    },
    // 充值弹窗
    recharge(t) {
      this.showRecharge = true;
      this.rechargeForm.type = t;
      this.rechargeForm.show_type = t == 1 ? "验证码" : "营销短信";
      this.rechargeForm.price = t == 1 ? this.price.code : this.price.market;
      console.log(this.price.code);
    },
    closeRecharge() {
      this.showRecharge = false;
      this.rechargeItems.forEach((item) => {
        item.selected = false;
      });
      this.rechargeForm = {
        num: 1,
        type: 1,
        price: 0,
        selectNum: 0,
      };
    },
    // 选择充值项
    selectRechargeItem(i) {
      this.rechargeItems.forEach((item) => {
        item.selected = false;
      });
      this.rechargeItems[i].selected = true;
      this.rechargeForm.selectNum = this.rechargeItems[i].num;
    },
    // 购买
    submitBuy() {
      if (this.rechargeItems.some((x) => x.selected)) {
        var t = new Date().getTime();
        this.ordersn = "a" + this.app_id + "t" + t;
        var data = {
          token: this.token,
          app_id: this.app_id,
          return_url: "http://ydd.58zltc.com/#/paySuccess",
          type: this.rechargeForm.type,
          num: this.rechargeForm.selectNum * this.rechargeForm.num,
          nonce: this.ordersn,
        };
        console.log(data);
        this.payOrder();
      } else {
        this.$message("请选择购买条数");
      }
    },
    // 展示二维码
    payOrder() {
      this.showQrcode = true;
      var baseUrl =
        this.status == "test"
          ? "http://cs.58zltc.com/api/sms/feeQrcode?"
          : "http://www.58zltc.com/api/sms/feeQrcode?";
      var num = this.rechargeForm.selectNum * this.rechargeForm.num;
      this.qrcode =
        baseUrl +
        "token=" +
        this.token +
        "&app_id=" +
        this.app_id +
        "&type=" +
        this.rechargeForm.type +
        "&num=" +
        num +
        "&nonce=" +
        this.ordersn +
        "&return_url=https://jjtc.58zltc.com/paySuccess?";
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.crateQrcode();
      });
      this.getPayStatus();
    },
    // 生成二维码
    crateQrcode() {
      var canvas = this.$refs.qrcode;
      new QRCode(canvas, {
        width: 300,
        height: 300, // 高度
        text: this.qrcode, // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
      // console.log(this.qrcode)
    },
    // 关闭弹框,清除已经生成的二维码
    closeCode() {
      this.showQrcode = false;
      this.$refs.qrcode.innerHTML = "";
    },
    getPayStatus() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        nonce: this.ordersn,
      };
      SMSOrderDetail(data).then((res) => {
        if (res.code == 200) {
          if (res.data && res.data.pay_status == 2) {
            this.$message({
              type: "success",
              message: "支付成功！",
            });
            this.showQrcode = false;
            this.showRecharge = false;
            this.init();
          } else {
            setTimeout(() => {
              this.getPayStatus();
            }, 3000);
          }
        } else {
          setTimeout(() => {
            this.getPayStatus();
          }, 3000);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
    display: flex;
    .title_text {
      flex: 1;
    }
  }
  .page_form {
    // padding-top: 30px;
    font-size: 14px;
    .list_item {
      line-height: 30px;
      span {
        margin-right: 15px;
        color: #409eff;
      }
    }
    .part_title {
      padding-left: 10px;
      line-height: 50px;
      color: #333;
      font-size: 16px;
      font-weight: 600;
    }
    .balance_box {
      margin: 0 10px;
      padding: 20px;
      width: 330px;
      background: #f8f8f8;
      border-radius: 4px;
      .balance_title {
        margin-bottom: 15px;
        font-size: 14px;
      }
      .balance_num {
        display: flex;
        font-size: 42px;
        font-weight: 700;
        letter-spacing: 1px;
        .num {
          flex: 1;
          vertical-align: bottom;
        }
      }
    }
  }
  .page_bottom {
    margin-bottom: 20px;
  }
  .input_box {
    width: 320px;
  }
  .submit_button {
    margin-top: 30px;
    text-align: center;
  }
  .recharge {
    display: flex;
    border: 1px solid #dbdbdb;
    .recharge_left {
      width: 408px;
      display: flex;
      flex-wrap: wrap;
      padding: 8px;
      .recharge_item {
        width: 180px;
        height: 100px;
        cursor: pointer;
        margin: 8px;
        padding: 20px 15px;
        position: relative;
        .item_title {
          font-size: 18px;
        }
        .item_price {
          margin-top: 10px;
          font-size: 14px;
          span {
            color: #ff6600;
            font-size: 18px;
            font-weight: bold;
          }
        }
        .star_img {
          position: absolute;
          top: -3px;
          right: -10px;
          width: 50px;
        }
      }
      .status_normal {
        border: 1px solid #dbdbdb;
      }
      .status_normal:hover {
        border: 1px solid #adadad;
      }
      .status_selected {
        border: 1px solid #00a4ff;
        background: #eef9ff;
        .item_title {
          color: #00a4ff;
        }
      }
    }
    .recharge_right {
      flex: 1;
      background: #f7f8fa;
      padding: 40px 20px 0 20px;
      div {
        margin-bottom: 8px;
      }
      .show_price {
        margin-top: 15px;
        margin-bottom: 20px;
        span {
          font-size: 18px;
          font-weight: bold;
          color: #ff6600;
        }
      }
    }
  }
  .qrcode_box {
    width: 300px;
    height: 300px;
  }
}
</style>
